
import { environment } from "../environment"
import { api, apiS } from "./api-base";
import { Base64Encoder, getReqHeader } from "./tool-service";

// Auth驗證: 登入取token, refresh token
export const auth = async (username, password, grantType = grantTypeEnum.password) => {

    if (grantType === grantTypeEnum.refresh_token && sessionStorage.getItem('refresh_token') == null) {
        throw new Error('refresh_token in storage');
    }

    let formData = new FormData();
    formData.append('grant_type', grantType)
    switch (grantType) {
        case grantTypeEnum.password:
            formData.append('username', username);
            formData.append('password', password);
            break;
        case grantTypeEnum.refresh_token:
            formData.append('refresh_token', sessionStorage.getItem('refresh_token'));
            break;
        // case grantTypeEnum.client_credentials:
        //     let authStr = username + ':' + password;
        // break;
        default:
            break;
    }

    return await api({ url: `/${environment.contextPath}/tptoken/oauth/token`, method: 'post', data: formData });
}

export const auth2 = async (clientId, code, redirect_uri,code_verifier) => { //PKCE

    let headers = {
        'Content-Type': `application/x-www-form-urlencoded`,
         'Authorization': `Basic ${Base64Encoder(`${clientId}:`)}`
    }

    let formData = {
        'grant_type': 'authorization_code',
        'code': code,
        'redirect_uri': redirect_uri
    }

    if(code_verifier) formData.code_verifier = code_verifier;

    return await apiS({ url: `${environment.apiUrl}/oauth/token`, method: 'post', headers: headers ,data: formData },false,true);    
}

//取得 signBlock
export const getSignBlock = async () => {
    // console.log('get sign block')
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sessionStorage.getItem('access_token')}`
    };
    return await api({ url: `/${environment.contextPath}/getSignBlock`, headers: headers})
}

//get System Config (AA0510 / getAcConf)
export const getSystemConfig = async () => {
    // console.log('get system config')
    let ReqBody = {
        ReqHeader: getReqHeader('AA0510'),
        ReqBody: {}
    }
    return await apiS({ url: `/${environment.contextPath}/11/AA0510`, method: 'post', data: ReqBody })
}
// const grantTypeEnum = Object.freeze({"password":'password', "refresh_token":'refresh_token', "client_credentials":'client_credentials'})
export const grantTypeEnum = {
    password: 'password',
    refresh_token: 'refresh_token',
    client_credentials: 'client_credentials'
}



